import { useAuth } from "@/context/AuthContext";

/** Frontend RBAC helper. Mirrors backend `has_permission()` semantics. */
export function usePermissions() {
  const { user } = useAuth();
  const perms = user?.permissions || [];
  const isAdmin = user?.role === "admin";
  return {
    user,
    isAdmin,
    permissions: perms,
    has: (perm) => isAdmin && perms.includes(perm),
    hasAny: (...wanted) => isAdmin && wanted.some((p) => perms.includes(p)),
    hasAll: (...wanted) => isAdmin && wanted.every((p) => perms.includes(p)),
  };
}
